import script from "./DetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailView.vue?vue&type=script&lang=ts&setup=true"

import "./DetailView.vue?vue&type=style&index=0&id=3d5ff61e&lang=scss"
import "./DetailView.vue?vue&type=style&index=1&id=3d5ff61e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5ff61e"]])

export default __exports__